const countries = [
    {
        name: 'United States',
        code: 'US',
        dial_code: '+1',
        placeholder: '(201) 555-0123',
        validation: '^\\(\\d{3}\\) \\d{3}-\\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg'
    },
    {
        name: 'United Kingdom',
        code: 'GB',
        dial_code: '+44',
        placeholder: '07700 900123',
        validation: '^07\\d{3} \\d{6}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GB.svg'
    },
    {
        name: 'Afghanistan (‫افغانستان‬‎)',
        code: 'AF',
        dial_code: '+93',
        placeholder: '070 123 4567',
        validation: '^\\d{3} \\d{3} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/AF.svg'
    },
    {
        name: 'Albania (Shqipëri)',
        code: 'AL',
        dial_code: '+355',
        placeholder: '066 212 3456',
        validation: '^\\d{3} \\d{3} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/AL.svg'
    },
    {
        name: 'Algeria (‫الجزائر‬‎)',
        code: 'DZ',
        dial_code: '+213',
        placeholder: '0551 23 45 67',
        validation: '^\\d{4} \\d{2} \\d{2} \\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/DZ.svg'
    },
    {
        name: 'American Samoa',
        code: 'AS',
        dial_code: '+1684',
        placeholder: '(684) 733-1234',
        validation: '^\\(\\d{3}\\) \\d{3}-\\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/AS.svg'
    },
    {
        name: 'Andorra',
        code: 'AD',
        dial_code: '+376',
        placeholder: '312 345',
        validation: '^\\d{3} \\d{3}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/AD.svg'
    },
    {
        name: 'Angola',
        code: 'AO',
        dial_code: '+244',
        placeholder: '923 123 456',
        validation: '^\\d{3} \\d{3} \\d{3}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/AO.svg'
    },
    {
        name: 'Anguilla',
        code: 'AI',
        dial_code: '+1264',
        placeholder: '(264) 235-1234',
        validation: '^\\(\\d{3}\\) \\d{3}-\\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/AI.svg'
    },
    {
        name: 'Antigua and Barbuda',
        code: 'AG',
        dial_code: '+1268',
        placeholder: '(268) 464-1234',
        validation: '^\\(\\d{3}\\) \\d{3}-\\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/AG.svg'
    },
    {
        name: 'Argentina',
        code: 'AR',
        dial_code: '+54',
        placeholder: '011 15-2345-6789',
        validation: '^\\d{3} \\d{2}-\\d{4}-\\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/AR.svg'
    },
    {
        name: 'Armenia (Հայաստան)',
        code: 'AM',
        dial_code: '+374',
        placeholder: '077 123456',
        validation: '^\\d{3} \\d{6}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/AM.svg'
    },
    {
        name: 'Aruba',
        code: 'AW',
        dial_code: '+297',
        placeholder: '560 1234',
        validation: '^\\d{3} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/AW.svg'
    },
    {
        name: 'Australia',
        code: 'AU',
        dial_code: '+61',
        placeholder: '0412 345 678',
        validation: '^\\d{4} \\d{3} \\d{3}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/AU.svg'
    },
    {
        name: 'Austria (Österreich)',
        code: 'AT',
        dial_code: '+43',
        placeholder: '0664 123 4567',
        validation: '^06\\d{2} \\d{3} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/AT.svg'
    },
    {
        name: 'Azerbaijan (Azərbaycan)',
        code: 'AZ',
        dial_code: '+994',
        placeholder: '040 123 45 67',
        validation: '^\\d{3} \\d{3} \\d{2} \\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/AZ.svg'
    },
    {
        name: 'Bahamas',
        code: 'BS',
        dial_code: '+1242',
        placeholder: '(242) 359-1234',
        validation: '^\\(\\d{3}\\) \\d{3}-\\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BS.svg'
    },
    {
        name: 'Bahrain (‫البحرين‬‎)',
        code: 'BH',
        dial_code: '+973',
        placeholder: '3600 1234',
        validation: '^\\d{4} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BH.svg'
    },
    {
        name: 'Bangladesh (বাংলাদেশ)',
        code: 'BD',
        dial_code: '+880',
        placeholder: '01812-345678',
        validation: '^\\d{5}-\\d{6}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BD.svg'
    },
    {
        name: 'Barbados',
        code: 'BB',
        dial_code: '+1246',
        placeholder: '(246) 250-1234',
        validation: '^\\(\\d{3}\\) \\d{3}-\\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BB.svg'
    },
    {
        name: 'Belarus (Беларусь)',
        code: 'BY',
        dial_code: '+375',
        placeholder: '8 029 491-19-11',
        validation: '^\\d \\d{3} \\d{3}-\\d{2}-\\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BY.svg'
    },
    {
        name: 'Belgium (België)',
        code: 'BE',
        dial_code: '+32',
        placeholder: '0495 12 34 56',
        validation: '^04\\d{2} \\d{2} \\d{2} \\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BE.svg'
    },
    {
        name: 'Belize',
        code: 'BZ',
        dial_code: '+501',
        placeholder: '622-1234',
        validation: '^\\d{3}-\\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BZ.svg'
    },
    {
        name: 'Benin (Bénin)',
        code: 'BJ',
        dial_code: '+229',
        placeholder: '90 01 12 34',
        validation: '^\\d{2} \\d{2} \\d{2} \\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BJ.svg'
    },
    {
        name: 'Bermuda',
        code: 'BM',
        dial_code: '+1441',
        placeholder: '(441) 370-1234',
        validation: '^\\(\\d{3}\\) \\d{3}-\\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BM.svg'
    },
    {
        name: 'Bhutan (འབྲུག)',
        code: 'BT',
        dial_code: '+975',
        placeholder: '17 12 34 56',
        validation: '^\\d{2} \\d{2} \\d{2} \\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BT.svg'
    },
    {
        name: 'Bolivia',
        code: 'BO',
        dial_code: '+591',
        placeholder: '71234567',
        validation: '^\\d{8}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BO.svg'
    },
    {
        name: 'Bosnia and Herzegovina (Босна и Херцеговина)',
        code: 'BA',
        dial_code: '+387',
        placeholder: '061 123 456',
        validation: '^\\d{3} \\d{3} \\d{3}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BA.svg'
    },
    {
        name: 'Botswana',
        code: 'BW',
        dial_code: '+267',
        placeholder: '71 123 456',
        validation: '^\\d{2} \\d{3} \\d{3}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BW.svg'
    },
    {
        name: 'Brazil (Brasil)',
        code: 'BR',
        dial_code: '+55',
        placeholder: '(11) 96123-4567',
        validation: '^\\(\\d{2}\\) \\d{5}-\\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BR.svg'
    },
    {
        name: 'British Indian Ocean Territory',
        code: 'IO',
        dial_code: '+246',
        placeholder: '380 1234',
        validation: '^\\d{3} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/IO.svg'
    },
    {
        name: 'British Virgin Islands',
        code: 'VG',
        dial_code: '+1284',
        placeholder: '(284) 300-1234',
        validation: '^\\(\\d{3}\\) \\d{3}-\\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/VG.svg'
    },
    {
        name: 'Brunei',
        code: 'BN',
        dial_code: '+673',
        placeholder: '712 3456',
        validation: '^\\d{3} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BN.svg'
    },
    {
        name: 'Bulgaria (България)',
        code: 'BG',
        dial_code: '+359',
        placeholder: '048 123 456',
        validation: '^\\d{3} \\d{3} \\d{3}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BG.svg'
    },
    {
        name: 'Burkina Faso',
        code: 'BF',
        dial_code: '+226',
        placeholder: '70 12 34 56',
        validation: '^\\d{2} \\d{2} \\d{2} \\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BF.svg'
    },
    {
        name: 'Burundi (Uburundi)',
        code: 'BI',
        dial_code: '+257',
        placeholder: '79 56 12 34',
        validation: '^\\d{2} \\d{2} \\d{2} \\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BI.svg'
    },
    {
        name: 'Cambodia (កម្ពុជា)',
        code: 'KH',
        dial_code: '+855',
        placeholder: '091 234 567',
        validation: '^\\d{3} \\d{3} \\d{3}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/KH.svg'
    },
    {
        name: 'Cameroon (Cameroun)',
        code: 'CM',
        dial_code: '+237',
        placeholder: '6 71 23 45 67',
        validation: '^\\d \\d{2} \\d{2} \\d{2} \\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CM.svg'
    },
    {
        name: 'Canada',
        code: 'CA',
        dial_code: '+1',
        placeholder: '(506) 234-5678',
        validation: '^\\(\\d{3}\\) \\d{3}-\\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CA.svg'
    },
    {
        name: 'Cape Verde (Kabu Verdi)',
        code: 'CV',
        dial_code: '+238',
        placeholder: '991 12 34',
        validation: '^\\d{3} \\d{2} \\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CV.svg'
    },
    {
        name: 'Caribbean Netherlands',
        code: 'CN',
        dial_code: '+599',
        placeholder: '318 1234',
        validation: '^\\d{3} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CN.svg'
    },
    {
        name: 'Cayman Islands',
        code: 'KY',
        dial_code: '+1345',
        placeholder: '(345) 323-1234',
        validation: '^\\(\\d{3}\\) \\d{3}-\\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/KY.svg'
    },
    {
        name: 'Central African Republic (République centrafricaine)',
        code: 'CF',
        dial_code: '+236',
        placeholder: '70 01 23 45',
        validation: '^\\d{2} \\d{2} \\d{2} \\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CF.svg'
    },
    {
        name: 'Chad (Tchad)',
        code: 'TD',
        dial_code: '+235',
        placeholder: '63 01 23 45',
        validation: '^\\d{2} \\d{2} \\d{2} \\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/TD.svg'
    },
    {
        name: 'Chile',
        code: 'CL',
        dial_code: '+56',
        placeholder: '(2) 2123 4567',
        validation: '^\\(\\d\\) \\d{4} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CL.svg'
    },
    {
        name: 'China (中国)',
        code: 'CN',
        dial_code: '+86',
        placeholder: '131 2345 6789',
        validation: '^\\d{3} \\d{4} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CN.svg'
    },
    {
        name: 'Christmas Island',
        code: 'CX',
        dial_code: '+61',
        placeholder: '0412 345 678',
        validation: '^\\d{4} \\d{3} \\d{3}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CX.svg'
    },
    {
        name: 'Cocos (Keeling) Islands',
        code: 'CC',
        dial_code: '+61',
        placeholder: '0412 345 678',
        validation: '^\\d{4} \\d{3} \\d{3}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CC.svg'
    },
    {
        name: 'Colombia',
        code: 'CO',
        dial_code: '+57',
        placeholder: '321 1234567',
        validation: '^\\d{3} \\d{7}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CO.svg'
    },
    {
        name: 'Comoros (‫جزر القمر‬‎)',
        code: 'KM',
        dial_code: '+269',
        placeholder: '321 23 45',
        validation: '^\\d{3} \\d{2} \\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/KM.svg'
    },
    {
        name: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
        code: 'CD',
        dial_code: '+243',
        placeholder: '0991 234 567',
        validation: '^\\d{4} \\d{3} \\d{3}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CD.svg'
    },
    {
        name: 'Congo (Republic) (Congo-Brazzaville)',
        code: 'CG',
        dial_code: '+242',
        placeholder: '06 123 4567',
        validation: '^\\d{2} \\d{3} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CG.svg'
    },
    {
        name: 'Cook Islands',
        code: 'CK',
        dial_code: '+682',
        placeholder: '71 234',
        validation: '^\\d{2} \\d{3}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CK.svg'
    },
    {
        name: 'Costa Rica',
        code: 'CR',
        dial_code: '+506',
        placeholder: '8312 3456',
        validation: '^\\d{4} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CR.svg'
    },
    {
        name: 'Côte d’Ivoire',
        code: 'CI',
        dial_code: '+225',
        placeholder: '01 23 45 67',
        validation: '^\\d{2} \\d{2} \\d{2} \\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CI.svg'
    },
    {
        name: 'Croatia (Hrvatska)',
        code: 'HR',
        dial_code: '+385',
        placeholder: '092 123 4567',
        validation: '^\\d{3} \\d{3} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/HR.svg'
    },
    {
        name: 'Cuba',
        code: 'CU',
        dial_code: '+53',
        placeholder: '05 1234567',
        validation: '^\\d{2} \\d{7}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CU.svg'
    },
    {
        name: 'Curaçao',
        code: 'CW',
        dial_code: '+599',
        placeholder: '9 518 1234',
        validation: '^\\d \\d{3} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CW.svg'
    },
    {
        name: 'Cyprus (Κύπρος)',
        code: 'CY',
        dial_code: '+357',
        placeholder: '96 123456',
        validation: '^\\d{2} \\d{6}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CY.svg'
    },
    {
        name: 'Czech Republic (Česká republika)',
        code: 'CZ',
        dial_code: '+420',
        placeholder: '601 123 456',
        validation: '^\\d{3} \\d{3} \\d{3}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CZ.svg'
    },
    {
        name: 'Denmark (Danmark)',
        code: 'DK',
        dial_code: '+45',
        placeholder: '32 12 34 56',
        validation: '^\\d{2} \\d{2} \\d{2} \\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/DK.svg'
    },
    {
        name: 'Djibouti',
        code: 'DJ',
        dial_code: '+253',
        placeholder: '77 83 10 01',
        validation: '^\\d{2} \\d{2} \\d{2} \\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/DJ.svg'
    },
    {
        name: 'Dominica',
        code: 'DM',
        dial_code: '+1767',
        placeholder: '(767) 225-1234',
        validation: '^\\(\\d{3}\\) \\d{3}-\\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/DM.svg'
    },
    {
        name: 'Dominican Republic (República Dominicana)',
        code: 'DO',
        dial_code: '+1',
        placeholder: '(809) 234-5678',
        validation: '^\\(\\d{3}\\) \\d{3}-\\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/DO.svg'
    },
    {
        name: 'Ecuador',
        code: 'EC',
        dial_code: '+593',
        placeholder: '099 123 4567',
        validation: '^\\d{3} \\d{3} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/EC.svg'
    },
    {
        name: 'Egypt (‫مصر‬‎)',
        code: 'EG',
        dial_code: '+20',
        placeholder: '0100 123 4567',
        validation: '^\\d{4} \\d{3} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/EG.svg'
    },
    {
        name: 'El Salvador',
        code: 'SV',
        dial_code: '+503',
        placeholder: '7012 3456',
        validation: '^\\d{4} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SV.svg'
    },
    {
        name: 'Equatorial Guinea (Guinea Ecuatorial)',
        code: 'GQ',
        dial_code: '+240',
        placeholder: '222 123 456',
        validation: '^\\d{3} \\d{3} \\d{3}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GQ.svg'
    },
    {
        name: 'Eritrea',
        code: 'ER',
        dial_code: '+291',
        placeholder: '07 123 456',
        validation: '^\\d{2} \\d{3} \\d{3}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/ER.svg'
    },
    {
        name: 'Estonia (Eesti)',
        code: 'EE',
        dial_code: '+372',
        placeholder: '5123 4567',
        validation: '^\\d{4} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/EE.svg'
    },
    {
        name: 'Ethiopia',
        code: 'ET',
        dial_code: '+251',
        placeholder: '091 123 4567',
        validation: '^\\d{3} \\d{3} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/ET.svg'
    },
    {
        name: 'Falkland Islands (Islas Malvinas)',
        code: 'FK',
        dial_code: '+500',
        placeholder: '51234',
        validation: '^\\d{5}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/FK.svg'
    },
    {
        name: 'Faroe Islands (Føroyar)',
        code: 'FO',
        dial_code: '+298',
        placeholder: '211234',
        validation: '^\\d{6}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/FO.svg'
    },
    {
        name: 'Fiji',
        code: 'FJ',
        dial_code: '+679',
        placeholder: '701 2345',
        validation: '^\\d{3} \\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/FJ.svg'
    },
    {
        name: 'Finland (Suomi)',
        code: 'FI',
        dial_code: '+358',
        placeholder: '041 2345678',
        validation: '^\\d{3} \\d{7}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/FI.svg'
    },
    {
        name: 'France',
        code: 'FR',
        dial_code: '+33',
        placeholder: '06 12 34 56 78',
        validation: '^0[67] \\d{2} \\d{2} \\d{2} \\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/FR.svg'
    },
    {
        name: 'French Guiana (Guyane française)',
        code: 'GF',
        dial_code: '+594',
        placeholder: '0694 20 12 34',
        validation: '^\\d{4} \\d{2} \\d{2} \\d{2}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GF.svg'
    },
    {
        name: 'French Polynesia (Polynésie française)',
        code: 'PF',
        dial_code: '+689',
        placeholder: '87 12 34 56',
        validation: '^\\d{2} \\d{2} \\d{2} \\d{2}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/PF.svg'
    },
    {
        name: 'Gabon',
        code: 'GA',
        dial_code: '+241',
        placeholder: '06 03 12 34',
        validation: '^\\d{2} \\d{2} \\d{2} \\d{2}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GA.svg'
    },
    {
        name: 'Gambia',
        code: 'GM',
        dial_code: '+220',
        placeholder: '301 2345',
        validation: '^\\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GM.svg'
    },
    {
        name: 'Georgia (საქართველო)',
        code: 'GE',
        dial_code: '+995',
        placeholder: '555 12 34 56',
        validation: '^\\d{3} \\d{2} \\d{2} \\d{2}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GE.svg'
    },
    {
        name: 'Germany (Deutschland)',
        code: 'DE',
        dial_code: '+49',
        placeholder: '0171 1234567',
        validation: '^01[567]\\d \\d{7}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/DE.svg'
    },
    {
        name: 'Ghana (Gaana)',
        code: 'GH',
        dial_code: '+233',
        placeholder: '023 123 4567',
        validation: '^\\d{3} \\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GH.svg'
    },
    {
        name: 'Gibraltar',
        code: 'GI',
        dial_code: '+350',
        placeholder: '57123456',
        validation: '^\\d{8}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GI.svg'
    },
    {
        name: 'Greece (Ελλάδα)',
        code: 'GR',
        dial_code: '+30',
        placeholder: '691 234 5678',
        validation: '^\\d{3} \\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GR.svg'
    },
    {
        name: 'Greenland (Kalaallit Nunaat)',
        code: 'GL',
        dial_code: '+299',
        placeholder: '22 12 34',
        validation: '^\\d{2} \\d{2} \\d{2}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GL.svg'
    },
    {
        name: 'Grenada',
        code: 'GD',
        dial_code: '+1473',
        placeholder: '(473) 403-1234',
        validation: '^\\(\\d{3}\\) \\d{3}-\\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GD.svg'
    },
    {
        name: 'Guadeloupe',
        code: 'GP',
        dial_code: '+590',
        placeholder: '0690 00 12 34',
        validation: '^\\d{4} \\d{2} \\d{2} \\d{2}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GP.svg'
    },
    {
        name: 'Guam',
        code: 'GU',
        dial_code: '+1671',
        placeholder: '(671) 300-1234',
        validation: '^\\(\\d{3}\\) \\d{3}-\\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GU.svg'
    },
    {
        name: 'Guatemala',
        code: 'GT',
        dial_code: '+502',
        placeholder: '5123 4567',
        validation: '^\\d{4} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GT.svg'
    },
    {
        name: 'Guernsey',
        code: 'GG',
        dial_code: '+44',
        placeholder: '07781 123456',
        validation: '^\\d{5} \\d{6}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GG.svg'
    },
    {
        name: 'Guinea (Guinée)',
        code: 'GN',
        dial_code: '+224',
        placeholder: '601 12 34 56',
        validation: '^\\d{3} \\d{2} \\d{2} \\d{2}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GN.svg'
    },
    {
        name: 'Guinea-Bissau (Guiné Bissau)',
        code: 'GW',
        dial_code: '+245',
        placeholder: '955 012 345',
        validation: '^\\d{3} \\d{3} \\d{3}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GW.svg'
    },
    {
        name: 'Guyana',
        code: 'GY',
        dial_code: '+592',
        placeholder: '609 1234',
        validation: '^\\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GY.svg'
    },
    {
        name: 'Haiti',
        code: 'HT',
        dial_code: '+509',
        placeholder: '34 10 1234',
        validation: '^\\d{2} \\d{2} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/HT.svg'
    },
    {
        name: 'Honduras',
        code: 'HN',
        dial_code: '+504',
        placeholder: '9123-4567',
        validation: '^\\d{4}-\\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/HN.svg'
    },
    {
        name: 'Hong Kong (香港)',
        code: 'HK',
        dial_code: '+852',
        placeholder: '5123 4567',
        validation: '^\\d{4} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/HK.svg'
    },
    {
        name: 'Hungary (Magyarország)',
        code: 'HU',
        dial_code: '+36',
        placeholder: '(20) 123 4567',
        validation: '^\\(\\d{2}\\) \\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/HU.svg'
    },
    {
        name: 'Iceland (Ísland)',
        code: 'IS',
        dial_code: '+354',
        placeholder: '611 1234',
        validation: '^\\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/IS.svg'
    },
    {
        name: 'India (भारत)',
        code: 'IN',
        dial_code: '+91',
        placeholder: '81234 56789',
        validation: '^[6-9]\\d{4} \\d{5}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/IN.svg'
    },
    {
        name: 'Indonesia',
        code: 'ID',
        dial_code: '+62',
        placeholder: '0812-345-678',
        validation: '^\\d{4}-\\d{3}-\\d{3}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/ID.svg'
    },
    {
        name: 'Iran (‫ایران‬‎)',
        code: 'IR',
        dial_code: '+98',
        placeholder: '0912 345 6789',
        validation: '^\\d{4} \\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/IR.svg'
    },
    {
        name: 'Iraq (‫العراق‬‎)',
        code: 'IQ',
        dial_code: '+964',
        placeholder: '0791 234 5678',
        validation: '^\\d{4} \\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/IQ.svg'
    },
    {
        name: 'Ireland',
        code: 'IE',
        dial_code: '+353',
        placeholder: '085 012 3456',
        validation: '^\\d{3} \\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/IE.svg'
    },
    {
        name: 'Isle of Man',
        code: 'IM',
        dial_code: '+44',
        placeholder: '07924 123456',
        validation: '^\\d{5} \\d{6}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/IM.svg'
    },
    {
        name: 'Israel (‫ישראל‬‎)',
        code: 'IL',
        dial_code: '+972',
        placeholder: '050-234-5678',
        validation: '^\\d{3}-\\d{3}-\\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/IL.svg'
    },
    {
        name: 'Italy (Italia)',
        code: 'IT',
        dial_code: '+39',
        placeholder: '0347 1234567',
        validation: '^03\\d{2} \\d{7}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/IT.svg'
    },
    {
        name: 'Jamaica',
        code: 'JM',
        dial_code: '+1',
        placeholder: '(876) 210-1234',
        validation: '^\\(\\d{3}\\) \\d{3}-\\d{4',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/JM.svg'
    },
    {
        name: 'Japan (日本)',
        code: 'JP',
        dial_code: '+81',
        placeholder: '090-1234-5678',
        validation: '^\\d{3}-\\d{4}-\\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/JP.svg'
    },
    {
        name: 'Jersey',
        code: 'JE',
        dial_code: '+44',
        placeholder: '07797 712345',
        validation: '^\\d{5} \\d{6}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/JE.svg'
    },
    {
        name: 'Jordan (‫الأردن‬‎)',
        code: 'JO',
        dial_code: '+962',
        placeholder: '07 9012 3456',
        validation: '^\\d{2} \\d{4} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/JO.svg'
    },
    {
        name: 'Kazakhstan (Казахстан)',
        code: 'KZ',
        dial_code: '+7',
        placeholder: '8 (771) 000 9998',
        validation: '^\\d \\(\\d{3}\\) \\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/KZ.svg'
    },
    {
        name: 'Kenya',
        code: 'KE',
        dial_code: '+254',
        placeholder: '0712 123456',
        validation: '^\\d{4} \\d{6}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/KE.svg'
    },
    {
        name: 'Kiribati',
        code: 'KI',
        dial_code: '+686',
        placeholder: '72001234',
        validation: '^\\d{8}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/KI.svg'
    },
    {
        name: 'Kosovo',
        code: 'XK',
        dial_code: '+383',
        placeholder: '043 201 234',
        validation: '^\\d{3} \\d{3} \\d{3}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/XK.svg'
    },
    {
        name: 'Kuwait (‫الكويت‬‎)',
        code: 'KW',
        dial_code: '+965',
        placeholder: '500 12345',
        validation: '^\\d{3} \\d{5}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/KW.svg'
    },
    {
        name: 'Kyrgyzstan (Кыргызстан)',
        code: 'KG',
        dial_code: '+996',
        placeholder: '0700 123 456',
        validation: '^\\d{4} \\d{3} \\d{3}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/KG.svg'
    },
    {
        name: 'Laos (ລາວ)',
        code: 'LA',
        dial_code: '+856',
        placeholder: '020 23 123 456',
        validation: '^\\d{3} \\d{2} \\d{3} \\d{3}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/LA.svg'
    },
    {
        name: 'Latvia (Latvija)',
        code: 'LV',
        dial_code: '+371',
        placeholder: '21 234 567',
        validation: '^\\d{2} \\d{3} \\d{3}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/LV.svg'
    },
    {
        name: 'Lebanon (‫لبنان‬‎)',
        code: 'LB',
        dial_code: '+961',
        placeholder: '71 123 456',
        validation: '^\\d{2} \\d{3} \\d{3}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/LB.svg'
    },
    {
        name: 'Lesotho',
        code: 'LS',
        dial_code: '+266',
        placeholder: '5012 3456',
        validation: '^\\d{4} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/LS.svg'
    },
    {
        name: 'Liberia',
        code: 'LR',
        dial_code: '+231',
        placeholder: '077 012 3456',
        validation: '^\\d{3} \\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/LR.svg'
    },
    {
        name: 'Libya (‫ليبيا‬‎)',
        code: 'LY',
        dial_code: '+218',
        placeholder: '091-2345678',
        validation: '^\\d{3}-\\d{7}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/LY.svg'
    },
    {
        name: 'Liechtenstein',
        code: 'LI',
        dial_code: '+423',
        placeholder: '660 234 567',
        validation: '^\\d{3} \\d{3} \\d{3}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/LI.svg'
    },
    {
        name: 'Lithuania (Lietuva)',
        code: 'LT',
        dial_code: '+370',
        placeholder: '(8-612) 34567',
        validation: '^\\(\\d-\\d{3}\\) \\d{5}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/LT.svg'
    },
    {
        name: 'Luxembourg',
        code: 'LU',
        dial_code: '+352',
        placeholder: '628 123 456',
        validation: '^\\d{3} \\d{3} \\d{3}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/LU.svg'
    },
    {
        name: 'Macau (澳門)',
        code: 'MO',
        dial_code: '+853',
        placeholder: '6612 3456',
        validation: '^\\d{4} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MO.svg'
    },
    {
        name: 'Macedonia (FYROM) (Македонија)',
        code: 'MK',
        dial_code: '+389',
        placeholder: '072 345 678',
        validation: '^\\d{3} \\d{3} \\d{3}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MK.svg'
    },
    {
        name: 'Madagascar (Madagasikara)',
        code: 'MG',
        dial_code: '+261',
        placeholder: '032 12 345 67',
        validation: '^\\d{3} \\d{2} \\d{3} \\d{2}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MG.svg'
    },
    {
        name: 'Malawi',
        code: 'MW',
        dial_code: '+265',
        placeholder: '0991 23 45 67',
        validation: '^\\d{4} \\d{2} \\d{2} \\d{2}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MW.svg'
    },
    {
        name: 'Malaysia',
        code: 'MY',
        dial_code: '+60',
        placeholder: '012-345 6789',
        validation: '^\\d{3}-\\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MY.svg'
    },
    {
        name: 'Maldives',
        code: 'MV',
        dial_code: '+960',
        placeholder: '771-2345',
        validation: '^\\d{3}-\\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MV.svg'
    },
    {
        name: 'Mali',
        code: 'ML',
        dial_code: '+223',
        placeholder: '65 01 23 45',
        validation: '^\\d{2} \\d{2} \\d{2} \\d{2}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/ML.svg'
    },
    {
        name: 'Malta',
        code: 'MT',
        dial_code: '+356',
        placeholder: '9696 1234',
        validation: '^\\d{4} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MT.svg'
    },
    {
        name: 'Marshall Islands',
        code: 'MH',
        dial_code: '+692',
        placeholder: '235-1234',
        validation: '^\\d{3}-\\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MH.svg'
    },
    {
        name: 'Martinique',
        code: 'MQ',
        dial_code: '+596',
        placeholder: '0696 20 12 34',
        validation: '^\\d{4} \\d{2} \\d{2} \\d{2}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MQ.svg'
    },
    {
        name: 'Mauritania (‫موريتانيا‬‎)',
        code: 'MR',
        dial_code: '+222',
        placeholder: '22 12 34 56',
        validation: '^\\d{2} \\d{2} \\d{2} \\d{2}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MR.svg'
    },
    {
        name: 'Mauritius (Moris)',
        code: 'MU',
        dial_code: '+230',
        placeholder: '5251 2345',
        validation: '^\\d{4} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MU.svg'
    },
    {
        name: 'Mayotte',
        code: 'YT',
        dial_code: '+262',
        placeholder: '0639 01 23 45',
        validation: '^\\d{4} \\d{2} \\d{2} \\d{2}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/YT.svg'
    },
    {
        name: 'Mexico (México)',
        code: 'MX',
        dial_code: '+52',
        placeholder: '044 222 123 4567',
        validation: '^\\d{3} \\d{3} \\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MX.svg'
    },
    {
        name: 'Micronesia',
        code: 'FM',
        dial_code: '+691',
        placeholder: '350 1234',
        validation: '^\\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/FM.svg'
    },
    {
        name: 'Moldova (Republica Moldova)',
        code: 'MD',
        dial_code: '+373',
        placeholder: '0621 12 345',
        validation: '^\\d{4} \\d{2} \\d{3}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MD.svg'
    },
    {
        name: 'Monaco',
        code: 'MC',
        dial_code: '+377',
        placeholder: '06 12 34 56 78',
        validation: '^\\d{2} \\d{2} \\d{2} \\d{2} \\d{2}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MC.svg'
    },
    {
        name: 'Mongolia (Монгол)',
        code: 'MN',
        dial_code: '+976',
        placeholder: '8812 3456',
        validation: '^\\d{4} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MN.svg'
    },
    {
        name: 'Montenegro (Crna Gora)',
        code: 'ME',
        dial_code: '+382',
        placeholder: '067 622 901',
        validation: '^\\d{3} \\d{3} \\d{3}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/ME.svg'
    },
    {
        name: 'Montserrat',
        code: 'MS',
        dial_code: '+1664',
        placeholder: '(664) 492-3456',
        validation: '^\\(\\d{3}\\) \\d{3}-\\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MS.svg'
    },
    {
        name: 'Morocco (‫المغرب‬‎)',
        code: 'MA',
        dial_code: '+212',
        placeholder: '0650-123456',
        validation: '^\\d{4}-\\d{6}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MA.svg'
    },
    {
        name: 'Mozambique (Moçambique)',
        code: 'MZ',
        dial_code: '+258',
        placeholder: '82 123 4567',
        validation: '^\\d{2} \\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MZ.svg'
    },
    {
        name: 'Myanmar (Burma) (မြန်မာ)',
        code: 'MM',
        dial_code: '+95',
        placeholder: '09 212 3456',
        validation: '^\\d{2} \\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MM.svg'
    },
    {
        name: 'Namibia (Namibië)',
        code: 'NA',
        dial_code: '+264',
        placeholder: '081 123 4567',
        validation: '^\\d{3} \\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/NA.svg'
    },
    {
        name: 'Nauru',
        code: 'NR',
        dial_code: '+674',
        placeholder: '555 1234',
        validation: '^\\d{3} \\d{4}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/NR.svg'
    },
    {
        name: 'Nepal (नेपाल)',
        code: 'NP',
        dial_code: '+977',
        placeholder: '984-1234567',
        validation: '^\\d{3}-\\d{7}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/NP.svg'
    },
    {
        name: 'Netherlands (Nederland)',
        code: 'NL',
        dial_code: '+31',
        placeholder: '0612 345678',
        validation: '^06\\d{2} \\d{6}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/NL.svg'
    },
    {
        name: 'New Caledonia (Nouvelle-Calédonie)',
        code: 'NC',
        dial_code: '+687',
        placeholder: '75.12.34',
        validation: '^\\d{2}\\.\\d{2}\\.\\d{2}$|^\\d{6}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/NC.svg'
    },
    {
        name: 'New Zealand',
        code: 'NZ',
        dial_code: '+64',
        placeholder: '021 123 4567',
        validation: '^\\d{3}\\s\\d{3}\\s\\d{4}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/NZ.svg'
    },
    {
        name: 'Nicaragua',
        code: 'NI',
        dial_code: '+505',
        placeholder: '8123 4567',
        validation: '^\\d{4}\\s\\d{4}$|^\\d{8}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/NI.svg'
    },
    {
        name: 'Niger (Nijar)',
        code: 'NE',
        dial_code: '+227',
        placeholder: '93 12 34 56',
        validation: '^\\d{2}\\s\\d{2}\\s\\d{2}\\s\\d{2}$|^\\d{8}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/NE.svg'
    },
    {
        name: 'Nigeria',
        code: 'NG',
        dial_code: '+234',
        placeholder: '0802 123 4567',
        validation: '^\\d{4}\\s\\d{3}\\s\\d{4}$|^\\d{11}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/NG.svg'
    },
    {
        name: 'Niue',
        code: 'NU',
        dial_code: '+683',
        placeholder: '888 4012',
        validation: '^\\d{3}\\s\\d{4}$|^\\d{7}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/NU.svg'
    },
    {
        name: 'Norfolk Island',
        code: 'NF',
        dial_code: '+672',
        placeholder: '3 81234',
        validation: '^\\d{1}\\s\\d{5}$|^\\d{6}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/NF.svg'
    },
    {
        name: 'North Korea (조선 민주주의 인민 공화국)',
        code: 'KP',
        dial_code: '+850',
        placeholder: '0192 123 4567',
        validation: '^\\d{4}\\s\\d{3}\\s\\d{4}$|^\\d{11}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/KP.svg'
    },
    {
        name: 'Northern Mariana Islands',
        code: 'MP',
        dial_code: '+1670',
        placeholder: '(670) 234-5678',
        validation: '^\\(\\d{3}\\)\\s\\d{3}-\\d{4}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MP.svg'
    },
    {
        name: 'Norway (Norge)',
        code: 'NO',
        dial_code: '+47',
        placeholder: '406 12 345',
        validation: '^\\d{3}\\s\\d{2}\\s\\d{3}$|^\\d{8}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/NO.svg'
    },
    {
        name: 'Oman (‫عُمان‬‎)',
        code: 'OM',
        dial_code: '+968',
        placeholder: '9212 3456',
        validation: '^\\d{4}\\s\\d{4}$|^\\d{8}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/OM.svg'
    },
    {
        name: 'Pakistan (‫پاکستان‬‎)',
        code: 'PK',
        dial_code: '+92',
        placeholder: '0301 2345678',
        validation: '^\\d{4}\\s\\d{7}$|^\\d{11}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/PK.svg'
    },
    {
        name: 'Palau',
        code: 'PW',
        dial_code: '+680',
        placeholder: '620 1234',
        validation: '^\\d{3}\\s\\d{4}$|^\\d{7}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/PW.svg'
    },
    {
        name: 'Palestine (‫فلسطين‬‎)',
        code: 'PS',
        dial_code: '+970',
        placeholder: '0599 123 456',
        validation: '^\\d{4}\\s\\d{3}\\s\\d{3}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/PS.svg'
    },
    {
        name: 'Panama (Panamá)',
        code: 'PA',
        dial_code: '+507',
        placeholder: '6123-4567',
        validation: '^\\d{4}-\\d{4}$|^\\d{8}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/PA.svg'
    },
    {
        name: 'Papua New Guinea',
        code: 'PG',
        dial_code: '+675',
        placeholder: '7012 3456',
        validation: '^\\d{4}\\s\\d{4}$|^\\d{8}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/PG.svg'
    },
    {
        name: 'Paraguay',
        code: 'PY',
        dial_code: '+595',
        placeholder: '0961 456789',
        validation: '^\\d{4}\\s\\d{6}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/PY.svg'
    },
    {
        name: 'Peru (Perú)',
        code: 'PE',
        dial_code: '+51',
        placeholder: '912 345 678',
        validation: '^\\d{3}\\s\\d{3}\\s\\d{3}$|^\\d{9}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/PE.svg'
    },
    {
        name: 'Philippines',
        code: 'PH',
        dial_code: '+63',
        placeholder: '0905 123 4567',
        validation: '^\\d{4}\\s\\d{3}\\s\\d{4}$|^\\d{11}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/PH.svg'
    },
    {
        name: 'Poland (Polska)',
        code: 'PL',
        dial_code: '+48',
        placeholder: '512 345 678',
        validation: '^\\d{3}\\s\\d{3}\\s\\d{3}$|^\\d{9}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/PL.svg'
    },
    {
        name: 'Portugal',
        code: 'PT',
        dial_code: '+351',
        placeholder: '912 345 678',
        validation: '^\\d{3}\\s\\d{3}\\s\\d{3}$|^\\d{9}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/PT.svg'
    },
    {
        name: 'Puerto Rico',
        code: 'PR',
        dial_code: '+1',
        placeholder: '(787) 234-5678',
        validation: '^\\(\\d{3}\\)\\s\\d{3}-\\d{4}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/PR.svg'
    },
    {
        name: 'Qatar (‫قطر‬‎)',
        code: 'QA',
        dial_code: '+974',
        placeholder: '3312 3456',
        validation: '^\\d{4}\\s\\d{4}$|^\\d{8}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/QA.svg'
    },
    {
        name: 'Réunion (La Réunion)',
        code: 'RE',
        dial_code: '+262',
        placeholder: '0692 12 34 56',
        validation: '^\\d{4}\\s\\d{2}\\s\\d{2}\\s\\d{2}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/RE.svg'
    },
    {
        name: 'Romania (România)',
        code: 'RO',
        dial_code: '+40',
        placeholder: '0712 034 567',
        validation: '^\\d{4}\\s\\d{3}\\s\\d{3}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/RO.svg'
    },
    {
        name: 'Russia (Россия)',
        code: 'RU',
        dial_code: '+7',
        placeholder: '8 (912) 345-67-89',
        validation: '^\\d{1}\\s\\(\\d{3}\\)\\s\\d{3}-\\d{2}-\\d{2}$|^\\d{11}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/RU.svg'
    },
    {
        name: 'Rwanda',
        code: 'RW',
        dial_code: '+250',
        placeholder: '0720 123 456',
        validation: '^\\d{4}\\s\\d{3}\\s\\d{3}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/RW.svg'
    },
    {
        name: 'Saint Barthélemy',
        code: 'BL',
        dial_code: '+590',
        placeholder: '0690 00 12 34',
        validation: '^\\d{4}\\s\\d{2}\\s\\d{2}\\s\\d{2}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BL.svg'
    },
    {
        name: 'Saint Helena',
        code: 'SH',
        dial_code: '+290',
        placeholder: '51234',
        validation: '^\\d{5}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SH.svg'
    },
    {
        name: 'Saint Kitts and Nevis',
        code: 'KN',
        dial_code: '+1869',
        placeholder: '(869) 765-2917',
        validation: '^\\(\\d{3}\\)\\s\\d{3}-\\d{4}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/KN.svg'
    },
    {
        name: 'Saint Lucia',
        code: 'LC',
        dial_code: '+1758',
        placeholder: '(758) 284-5678',
        validation: '^\\(\\d{3}\\)\\s\\d{3}-\\d{4}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/LC.svg'
    },
    {
        name: 'Saint Martin (Saint-Martin (partie française))',
        code: 'MF',
        dial_code: '+590',
        placeholder: '0690 00 12 34',
        validation: '^\\d{4}\\s\\d{2}\\s\\d{2}\\s\\d{2}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/MF.svg'
    },
    {
        name: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
        code: 'PM',
        dial_code: '+508',
        placeholder: '055 12 34',
        validation: '^\\d{3}\\s\\d{2}\\s\\d{2}$|^\\d{7}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/PM.svg'
    },
    {
        name: 'Saint Vincent and the Grenadines',
        code: 'VC',
        dial_code: '+1784',
        placeholder: '(784) 430-1234',
        validation: '^\\(\\d{3}\\)\\s\\d{3}-\\d{4}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/VC.svg'
    },
    {
        name: 'Samoa',
        code: 'WS',
        dial_code: '+685',
        placeholder: '72 12345',
        validation: '^\\d{2}\\s\\d{5}$|^\\d{7}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/WS.svg'
    },
    {
        name: 'San Marino',
        code: 'SM',
        dial_code: '+378',
        placeholder: '66 66 12 12',
        validation: '^\\d{2}\\s\\d{2}\\s\\d{2}\\s\\d{2}$|^\\d{8}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SM.svg'
    },
    {
        name: 'São Tomé and Príncipe (São Tomé e Príncipe)',
        code: 'ST',
        dial_code: '+239',
        placeholder: '981 2345',
        validation: '^\\d{3}\\s\\d{4}$|^\\d{7}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/ST.svg'
    },
    {
        name: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
        code: 'SA',
        dial_code: '+966',
        placeholder: '051 234 5678',
        validation: '^\\d{3}\\s\\d{3}\\s\\d{4}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SA.svg'
    },
    {
        name: 'Senegal (Sénégal)',
        code: 'SN',
        dial_code: '+221',
        placeholder: '70 123 45 67',
        validation: '^\\d{2}\\s\\d{3}\\s\\d{2}\\s\\d{2}$|^\\d{9}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SN.svg'
    },
    {
        name: 'Serbia (Србија)',
        code: 'RS',
        dial_code: '+381',
        placeholder: '060 1234567',
        validation: '^\\d{3}\\s\\d{7}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/RS.svg'
    },
    {
        name: 'Seychelles',
        code: 'SC',
        dial_code: '+248',
        placeholder: '2 510 123',
        validation: '^\\d{1}\\s\\d{3}\\s\\d{3}$|^\\d{7}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SC.svg'
    },
    {
        name: 'Sierra Leone',
        code: 'SL',
        dial_code: '+232',
        placeholder: '(025) 123456',
        validation: '^\\(\\d{3}\\)\\s\\d{6}$|^\\d{9}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SL.svg'
    },
    {
        name: 'Singapore',
        code: 'SG',
        dial_code: '+65',
        placeholder: '8123 4567',
        validation: '^\\d{4}\\s\\d{4}$|^\\d{8}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SG.svg'
    },
    {
        name: 'Sint Maarten',
        code: 'SX',
        dial_code: '+1721',
        placeholder: '(721) 520-5678',
        validation: '^\\(\\d{3}\\)\\s\\d{3}-\\d{4}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SX.svg'
    },
    {
        name: 'Slovakia (Slovensko)',
        code: 'SK',
        dial_code: '+421',
        placeholder: '0912 123 456',
        validation: '^\\d{4}\\s\\d{3}\\s\\d{3}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SK.svg'
    },
    {
        name: 'Slovenia (Slovenija)',
        code: 'SI',
        dial_code: '+386',
        placeholder: '031 234 567',
        validation: '^\\d{3}\\s\\d{3}\\s\\d{3}$|^\\d{9}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SI.svg'
    },
    {
        name: 'Solomon Islands',
        code: 'SB',
        dial_code: '+677',
        placeholder: '74 21234',
        validation: '^\\d{2}\\s\\d{5}$|^\\d{7}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SB.svg'
    },
    {
        name: 'Somalia (Soomaaliya)',
        code: 'SO',
        dial_code: '+252',
        placeholder: '7 1123456',
        validation: '^\\d{1}\\s\\d{7}$|^\\d{8}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SO.svg'
    },
    {
        name: 'South Africa',
        code: 'ZA',
        dial_code: '+27',
        placeholder: '071 123 4567',
        validation: '^\\d{3}\\s\\d{3}\\s\\d{4}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/ZA.svg'
    },
    {
        name: 'South Korea (대한민국)',
        code: 'KR',
        dial_code: '+82',
        placeholder: '010-0000-0000',
        validation: '^\\d{3}-\\d{4}-\\d{4}$|^\\d{11}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/KR.svg'
    },
    {
        name: 'South Sudan (‫جنوب السودان‬‎)',
        code: 'SS',
        dial_code: '+211',
        placeholder: '0977 123 456',
        validation: '^\\d{4}\\s\\d{3}\\s\\d{3}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SS.svg'
    },
    {
        name: 'Spain (España)',
        code: 'ES',
        dial_code: '+34',
        placeholder: '612 34 56 78',
        validation: '^\\d{3}\\s\\d{2}\\s\\d{2}\\s\\d{2}$|^\\d{9}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/ES.svg'
    },
    {
        name: 'Sri Lanka (ශ්‍රී ලංකාව)',
        code: 'LK',
        dial_code: '+94',
        placeholder: '071 234 5678',
        validation: '^\\d{3}\\s\\d{3}\\s\\d{4}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/LK.svg'
    },
    {
        name: 'Sudan (‫السودان‬‎)',
        code: 'SD',
        dial_code: '+249',
        placeholder: '091 123 1234',
        validation: '^\\d{3}\\s\\d{3}\\s\\d{4}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SD.svg'
    },
    {
        name: 'Suriname',
        code: 'SR',
        dial_code: '+597',
        placeholder: '741-2345',
        validation: '^\\d{3}-\\d{4}$|^\\d{7}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SR.svg'
    },
    {
        name: 'Svalbard and Jan Mayen',
        code: 'SJ',
        dial_code: '+47',
        placeholder: '412 34 567',
        validation: '^\\d{3}\\s\\d{2}\\s\\d{3}$|^\\d{8}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SJ.svg'
    },
    {
        name: 'Swaziland',
        code: 'SZ',
        dial_code: '+268',
        placeholder: '7612 3456',
        validation: '^\\d{4}\\s\\d{4}$|^\\d{8}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SZ.svg'
    },
    {
        name: 'Sweden (Sverige)',
        code: 'SE',
        dial_code: '+46',
        placeholder: '070-123 45 67',
        validation: '^\\d{3}-\\d{3}\\s\\d{2}\\s\\d{2}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SE.svg'
    },
    {
        name: 'Switzerland (Schweiz)',
        code: 'CH',
        dial_code: '+41',
        placeholder: '079 123 45 67',
        validation: '^07[0-9] \\d{3} \\d{2} \\d{2}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CH.svg'
    },
    {
        name: 'Syria (‫سوريا‬‎)',
        code: 'SY',
        dial_code: '+963',
        placeholder: '0944 567 890',
        validation: '^\\d{4}\\s\\d{3}\\s\\d{3}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SY.svg'
    },
    {
        name: 'Taiwan (台灣)',
        code: 'TW',
        dial_code: '+886',
        placeholder: '0912 345 678',
        validation: '^\\d{4}\\s\\d{3}\\s\\d{3}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/TW.svg'
    },
    {
        name: 'Tajikistan',
        code: 'TJ',
        dial_code: '+992',
        placeholder: '917 12 3456',
        validation: '^\\d{3}\\s\\d{2}\\s\\d{4}$|^\\d{9}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/TJ.svg'
    },
    {
        name: 'Tanzania',
        code: 'TZ',
        dial_code: '+255',
        placeholder: '0621 234 567',
        validation: '^\\d{4}\\s\\d{3}\\s\\d{3}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/TZ.svg'
    },
    {
        name: 'Thailand (ไทย)',
        code: 'TH',
        dial_code: '+66',
        placeholder: '081 234 5678',
        validation: '^\\d{3}\\s\\d{3}\\s\\d{4}$|^\\d{10}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/TH.svg'
    },
    {
        name: 'Timor-Leste',
        code: 'TL',
        dial_code: '+670',
        placeholder: '7721 2345',
        validation: '^\\d{4}\\s\\d{4}$|^\\d{8}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/TL.svg'
    },
    {
        name: 'Togo',
        code: 'TG',
        dial_code: '+228',
        placeholder: '90 11 23 45',
        validation: '^\\d{2}\\s\\d{2}\\s\\d{2}\\s\\d{2}$|^\\d{8}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/TG.svg'
    },
    {
        name: 'Tokelau',
        code: 'TK',
        dial_code: '+690',
        placeholder: '7290',
        validation: '^\\d{4}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/TK.svg'
    },
    {
        name: 'Tonga',
        code: 'TO',
        dial_code: '+676',
        placeholder: '771 5123',
        validation: '^\\d{3}\\s\\d{4}$|^\\d{7}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/TO.svg'
    },
    {
        name: 'Trinidad and Tobago',
        code: 'TT',
        dial_code: '+1868',
        placeholder: '(868) 291-1234',
        validation: '^\\(\\d{3}\\)\\s\\d{3}-\\d{4}$|^\\d{10}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/TT.svg'
    },
    {
        name: 'Tunisia (‫تونس‬‎)',
        code: 'TN',
        dial_code: '+216',
        placeholder: '20 123 456',
        validation: '^\\d{2}\\s\\d{3}\\s\\d{3}$|^\\d{8}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/TN.svg'
    },
    {
        name: 'Turkey (Türkiye)',
        code: 'TR',
        dial_code: '+90',
        placeholder: '0501 234 56 78',
        validation: '^\\d{4}\\s\\d{3}\\s\\d{2}\\s\\d{2}$|^\\d{11}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/TR.svg'
    },
    {
        name: 'Turkmenistan',
        code: 'TM',
        dial_code: '+993',
        placeholder: '8 66 123456',
        validation: '^\\d{1}\\s\\d{2}\\s\\d{6}$|^\\d{9}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/TM.svg'
    },
    {
        name: 'Turks and Caicos Islands',
        code: 'TC',
        dial_code: '+1649',
        placeholder: '(649) 231-1234',
        validation: '^\\(\\d{3}\\)\\s\\d{3}-\\d{4}$|^\\d{10}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/TC.svg'
    },
    {
        name: 'Tuvalu',
        code: 'TV',
        dial_code: '+688',
        placeholder: '901234',
        validation: '^\\d{6}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/TV.svg'
    },
    {
        name: 'U.S. Virgin Islands',
        code: 'VI',
        dial_code: '+1340',
        placeholder: '(340) 642-1234',
        validation: '^\\(\\d{3}\\)\\s\\d{3}-\\d{4}$|^\\d{10}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/VI.svg'
    },
    {
        name: 'Uganda',
        code: 'UG',
        dial_code: '+256',
        placeholder: '0712 345678',
        validation: '^\\d{4}\\s\\d{6}$|^\\d{10}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/UG.svg'
    },
    {
        name: 'Ukraine (Україна)',
        code: 'UA',
        dial_code: '+380',
        placeholder: '039 123 4567',
        validation: '^\\d{3}\\s\\d{3}\\s\\d{4}$|^\\d{10}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/UA.svg'
    },
    {
        name: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
        code: 'AE',
        dial_code: '+971',
        placeholder: '050 123 4567',
        validation: '^\\d{3}\\s\\d{3}\\s\\d{4}$|^\\d{10}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/AE.svg'
    },
    {
        name: 'United Kingdom',
        code: 'GB',
        dial_code: '+44',
        placeholder: '07700 900123',
        validation: '^07\\d{3} \\d{6}$',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GB.svg'
    },
    {
        name: 'United States',
        code: 'US',
        dial_code: '+1',
        placeholder: '(201) 555-0123',
        validation: '^\\(\\d{3}\\)\\s\\d{3}-\\d{4}$|^\\d{10}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg'
    },
    {
        name: 'Uruguay',
        code: 'UY',
        dial_code: '+598',
        placeholder: '094 231 234',
        validation: '^\\d{3}\\s\\d{3}\\s\\d{3}$|^\\d{9}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/UY.svg'
    },
    {
        name: 'Uzbekistan (Oʻzbekiston)',
        code: 'UZ',
        dial_code: '+998',
        placeholder: '8 91 234 56 78',
        validation: '^\\d{1}\\s\\d{2}\\s\\d{3}\\s\\d{2}\\s\\d{2}$|^\\d{10}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/UZ.svg'
    },
    {
        name: 'Vanuatu',
        code: 'VU',
        dial_code: '+678',
        placeholder: '591 2345',
        validation: '^\\d{3}\\s\\d{4}$|^\\d{7}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/VU.svg'
    },
    {
        name: 'Vatican City (Città del Vaticano)',
        code: 'VA',
        dial_code: '+39',
        placeholder: '312 345 6789',
        validation: '^\\d{3}\\s\\d{3}\\s\\d{4}$|^\\d{10}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/VA.svg'
    },
    {
        name: 'Venezuela',
        code: 'VE',
        dial_code: '+58',
        placeholder: '0412-1234567',
        validation: '^\\d{4}-\\d{7}$|^\\d{11}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/VE.svg'
    },
    {
        name: 'Vietnam (Việt Nam)',
        code: 'VN',
        dial_code: '+84',
        placeholder: '091 234 56 78',
        validation: '^\\d{3}\\s\\d{3}\\s\\d{2}\\s\\d{2}$|^\\d{10}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/VN.svg'
    },
    {
        name: 'Wallis and Futuna (Wallis-et-Futuna)',
        code: 'WF',
        dial_code: '+681',
        placeholder: '50 12 34',
        validation: '^\\d{2}\\s\\d{2}\\s\\d{2}$|^\\d{6}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/WF.svg'
    },
    {
        name: 'Western Sahara (‫الصحراء الغربية‬‎)',
        code: 'EH',
        dial_code: '+212',
        placeholder: '0650-123456',
        validation: '^\\d{4}-\\d{6}$|^\\d{10}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/EH.svg'
    },
    {
        name: 'Yemen (‫اليمن‬‎)',
        code: 'YE',
        dial_code: '+967',
        placeholder: '0712 345 678',
        validation: '^\\d{4}\\s\\d{3}\\s\\d{3}$|^\\d{10}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/YE.svg'
    },
    {
        name: 'Zambia',
        code: 'ZM',
        dial_code: '+260',
        placeholder: '095 5123456',
        validation: '^\\d{3}\\s\\d{7}$|^\\d{10}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/ZM.svg'
    },
    {
        name: 'Zimbabwe',
        code: 'ZW',
        dial_code: '+263',
        placeholder: '071 234 5678',
        validation: '^\\d{3}\\s\\d{3}\\s\\d{4}$|^\\d{10}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/ZW.svg'
    },
    {
        name: 'Åland Islands',
        code: 'AX',
        dial_code: '+358',
        placeholder: '041 2345678',
        validation: '^\\d{3}\\s\\d{7}$|^\\d{10}',
        flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/AX.svg'
    }
]

export default countries
